import { render, staticRenderFns } from "./SchemaReconciliation.vue?vue&type=template&id=08a0c8cf&scoped=true&"
import script from "./SchemaReconciliation.vue?vue&type=script&setup=true&lang=js&"
export * from "./SchemaReconciliation.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SchemaReconciliation.vue?vue&type=style&index=0&id=08a0c8cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a0c8cf",
  null
  
)

export default component.exports